import Vue from 'vue';
import http from './lib/http';
import Directory from './components/directory.vue';

Vue.prototype.$http = http;

// eslint-disable-next-line no-new
new Vue({
  el: '#members-directory',
  components: {
    Directory,
  },
  render(createElement) {
    return createElement(Directory);
  },
});
